// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hr-page-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.hr-page-title svg {
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  color: #2563eb;
  stroke-width: 1.8;
}

.hr-tile .hr-tile-icon {
  display: grid;
  width: 72px;
  height: 72px;
  margin-bottom: 20px;
  border-radius: 20px;
  background: #eff6ff;
  color: #2563eb;
  place-items: center;
  transition: transform 0.2s ease;
}

.hr-tile-icon svg {
  width: 36px;
  height: 36px;
}

.hr-tile:hover .hr-tile-icon {
  transform: scale(1.06);
}
`, "",{"version":3,"sources":["webpack://./src/pages/css/HR.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[".hr-page-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.hr-page-title svg {\n  width: 30px;\n  height: 30px;\n  flex-shrink: 0;\n  color: #2563eb;\n  stroke-width: 1.8;\n}\n\n.hr-tile .hr-tile-icon {\n  display: grid;\n  width: 72px;\n  height: 72px;\n  margin-bottom: 20px;\n  border-radius: 20px;\n  background: #eff6ff;\n  color: #2563eb;\n  place-items: center;\n  transition: transform 0.2s ease;\n}\n\n.hr-tile-icon svg {\n  width: 36px;\n  height: 36px;\n}\n\n.hr-tile:hover .hr-tile-icon {\n  transform: scale(1.06);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
